import React, { useEffect, useRef } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { store } from '../../../config/firebase';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import OverlayScoreboard from '../../ui/gameControls/overlayScoreboard';
import ScoringDisplay from '../../ui/playerDisplay/scoringDisplay';
import { useColorMode } from '../../../hooks/colorModeProvider';

const GameScorecardOverlay = () => {
  const { gameId } = useParams();
  const { mode, setMode } = useColorMode();
  const initialModeRef = useRef(mode);
  const [fsGame, setFSGame] = React.useState(null);

  useEffect(() => {
    const previousMode = initialModeRef.current;
    setMode('dark');

    return () => {
      setMode(previousMode);
    };
  }, [setMode]);

  useEffect(() => {
    const docRef = doc(store, 'games', gameId);
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const gameData = { id: docSnap.id, ...docSnap.data() };
        setFSGame(gameData);
      } else {
        setFSGame(null);
      }
    });

    return () => unsubscribe();
  }, [gameId]);

  if (!fsGame) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        sx={{ backgroundColor: 'transparent', color: 'text.primary' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      px={2}
      py={3}
      sx={{
        backgroundColor: 'transparent',
        color: 'text.primary'
      }}>
      <Typography variant="h4" fontWeight={800} textAlign="center" mb={1.5}>
        {fsGame.name ?? 'Game Scorecard'}
      </Typography>
      <Box
        sx={{
          width: '100%',
          maxWidth: 1200,
          p: 2,
          mb: 2,
          borderRadius: 3,
          backgroundColor: 'rgba(10, 18, 32, 0.9)',
          backdropFilter: 'blur(2px)'
        }}>
        <ScoringDisplay game={fsGame} />
      </Box>
      {fsGame.sets?.length && (
        <Box
          sx={{
            width: '100%',
            maxWidth: 1200,
            p: 2,
            borderRadius: 3,
            backgroundColor: 'rgba(10, 18, 32, 0.9)',
            backdropFilter: 'blur(2px)'
          }}>
          <OverlayScoreboard game={fsGame} />
        </Box>
      )}
    </Box>
  );
};

export default GameScorecardOverlay;
